import { FOfferType, offerTypeFromJsonQuery } from '../../../JsonQuery';
import { useContext } from './useContext';

export function useOfferType(): FOfferType {
  const { jsonQuery } = useContext();

  return offerTypeFromJsonQuery(jsonQuery);
}
